const en: Record<string, string> = {
    otherGames: 'Other games',
    createGame: 'Create game',
    join: 'Join',
    joinError: 'Unable to join the game',
    pseudo: 'Nickname',
    turn: 'Turn',
    confirmChoice: 'Confirm choice?',
    thinking: 'is thinking...',
    waitingBets: 'Waiting for other bets...',
    endTurn: 'End of turn?',
    yourBet: 'Your turn to bet!',
    winnerIs: '{name} won!',
    youWon: 'You won!',
    nobodyWon: 'Nobody won :o',
    clickCardToContinue: 'Click the card to continue',
    waitingForTurnHolder: 'Waiting for {name}...',
    won: 'Won!',
    newTurn: 'New turn?',
    newGame: 'New game',
    code: 'Code',
    invite: 'Invite',
    linkCopied: 'Link copied!',
    connectedPlayers: 'Connected players:',
    waitingOrganizer: 'Waiting for the organizer',
    playlist: 'Playlist',
    Rock: 'Rock',
    playlistPop: 'Pop',
    'Best Hit - France': 'Best Hit - France',
    '100% France': '100% France',
    'Plaisirs coupables': 'Guilty Pleasures',
    'Rock - Deutschland': 'Rock - Germany',
    'Best Hit - USA': 'Best Hit - USA',
    playlistSummerParty: 'Summer Party',
    playlistHipHop: 'Hip-Hop',
    playlist80s: '80s',
    playlistJazz: 'Jazz',
    playlistElectro: 'Electro',
    country_france: 'France',
    country_usa: 'USA',
    country_deutschland: 'Germany',
    yourTurn: '{name}!',
    yourTurnPrefix: 'Your turn, ',
    turnOfPrefix: '',
    turnOfSuffix: "'s turn",
    fatalError: 'A fatal error has occurred.',
    sendError: 'Please share your actions and send me this message:',
    reloadGame: 'You need to reload the game :c',
    backToHome: 'Back to home',
    codedBy: 'Coded with love by',
    thanks: 'Acknowledgments',
    seeGames: 'Website',
    home: 'Home',
    menu: 'Menu :)',
    readyConfirm: 'Turn ok for me?',
    waitingReady: 'Waiting...',
    waitingForPlayers: 'Waiting for: {names}',
    playlistExhausted: 'exhausted!',
    playlistSwitched: 'Playlist {old} exhausted! Switching to {new}',
    cardsToWin: 'Cards to win',
    gameOver: '{name} won the game!',
    backToHomeButton: 'Back to home',
    disclaimer: 'This game is a personal project not affiliated with Hitster.',
    copyright: 'Hitster is the intellectual property of © 2022 Koninklijke Jumbo B.V. | © game concept by Slættaratindur AB & Friends.',
};

export default en;
